import React from 'react';
import styled from 'styled-components';
import { Header } from '../layout';

interface PresentationHeaderPanelProps {
  leftContent: React.ReactNode;
  centerContent: React.ReactNode;
  rightContent: React.ReactNode;
}

export const PresentationHeaderPanel: React.FC<PresentationHeaderPanelProps> = ({
  leftContent,
  centerContent,
  rightContent
}) => {
  return (
    <Header>
      <HeaderContentBox>{leftContent}</HeaderContentBox>
      <HeaderContentBox style={{ justifyContent: 'center' }}>{centerContent}</HeaderContentBox>
      <HeaderContentBox>{rightContent}</HeaderContentBox>
    </Header>
  );
};

const HeaderContentBox = styled.div`
  display: flex;
  flex: 1;
  &:first-child > * {
    margin-right: auto;
  }
  &:last-child > * {
    margin-left: auto;
  }
`;
